import React from 'react'
import { InitialValue as modalInitialValue } from 'context/error/reducer'

export default React.createContext({
  modal: modalInitialValue,
  setError: (title) => {}
})
